import { createSlice } from "@reduxjs/toolkit";

import type { IGoalState, IGoalAction, IGoal } from "./types";
import type { IAppState } from "../../types";

const initialState = {
  goals: [],
};

const goalsSlice = createSlice({
  name: "goals",
  initialState,
  reducers: {
    // reducer to set the goals in the state
    setGoals: (state: IGoalState, action: any) => {
      state.goals = action.payload;
    },

    // reducer to add a new goal
    addGoal: (state: IGoalState, action: IGoalAction) => {
      state.goals.unshift(action.payload);
    },
    // reducer to delete a goal
    deleteGoal: (state: IGoalState, action: IGoalAction) => {
      state.goals = state.goals.filter(
        (goal: IGoal) => goal.id !== action.payload.id
      );
    },

    // reducer to update a goal
    updateGoal: (state: IGoalState, action: IGoalAction) => {
      state.goals.map((goal: IGoal) => {
        if (goal.id === action.payload.id) {
          goal.title = action.payload.title;
          goal.description = action.payload.description;
        }
        return goal;
      });
    },
    // reducer to toggle a favourite goal
    goalToggleFavourite: (state: IGoalState, action: IGoalAction) => {
      state.goals.map((goal: IGoal) => {
        // check if the goal is the one we want to toggle favourite
        if (goal.id === action.payload.id) {
          goal.favourite = !goal.favourite;
        }
        return goal;
      });
    },

    // reducer to toggle a complete goal
    goalToggleComplete: (state: IGoalState, action: IGoalAction) => {
      state.goals.map((goal: IGoal) => {
        // check if the goal is the one we want to toggle complete
        if (goal.id === action.payload.id) {
          goal.completed = !goal.completed;
        }
        return goal;
      });
    },
  },
});

// export select goals state
export const selectGoals = (state: IAppState) => state.goalsState.goals;
// export reducer actions
export const {
  setGoals,
  addGoal,
  deleteGoal,
  updateGoal,
  goalToggleFavourite,
  goalToggleComplete,
} = goalsSlice.actions;
// export the reducer
export const goalsReducer = goalsSlice.reducer;
